const SubscriptionService = require("Services/SubscriptionService");
import MixpanelService from "Services/MixpanelService";
import BaseBox from "Components/ui/BaseBox.vue";
import BaseLoading from "Components/ui/BaseLoading.vue";
import TipsContainer from "Components/ui/TipsContainer.vue";
import DoughnutChart from "Components/ui/DoughnutChart.vue";
import StandardTemplate from "Components/layout/StandardTemplate";
import { QueryManager, Operators, SupportedTypes, Sorting, NoteViews } from "Modules/NotesQueryManager.js";
import NoteStateTag from "./NoteStateTag";
import TheSidebarVue from "@/components/layout/TheSidebar.vue";

export default {
  name: "Dashboard",
  components: {
    BaseBox,
    BaseLoading,
    TipsContainer,
    DoughnutChart,
    StandardTemplate,
    NoteStateTag,
  },
  data () {
    return {
      loading: true,
      loadingUserManagement: true,
      subscription: undefined,
      pendingNotes: 0,
      // props for managing the state of the "setting up" window
      setupSteps: [
        { text: "Create Account", done: () => true, action: undefined },
        { text: "Verify Email", done: () => this.$store.getters.getEmailConfirmation, action: () => { } },
        { text: "Dictate", done: () => false, action: () => { } },
        // { text: "Refer a Friend", done: () => false, action: () => { window.location = "https://talkatoo.com/referral/"; } },
        // { text: "???", done: () => false, action: () => { } },
        // { text: "Profit!", done: () => false, action: () => { } }
      ],
      // props for the notes list
      loadingNotes: true,
      queryManager: new QueryManager({ paged: true, pageSize: 30, asTable: true }),
      rawNotes: [],
      recentNotes: [
        // { heading: "Today", notes: [] }, { heading: "Yesterday", notes: [] } // sample data
      ],

      // * donut chart props. modified in the helper function
      userList: undefined,
      inviteList: undefined,
      // structures for the donut chart
      dictationChartData: { datasets: [] },
      verifiedChartData: { datasets: [] },
      dictation: 0,
      maxDictation: 0,
      verified: 0,
      maxVerified: 0,
      invites: 0,

      noteUsage: {},
    };
  },
  created () {
    let subPromise = SubscriptionService.GetSubscription()
      .then((results) => {
        // setting required page data
        this.subscription = results.data;
        if (this.isUserVerified) {
          let nextBillingDate = new Date(this.subscription.payment_profile.next_billing_at);
          let lastBillingDate = new Date(this.subscription.payment_profile.next_billing_at);
          lastBillingDate.setMonth(lastBillingDate.getMonth() - 1);
          this.noteUsage.start = Intl.DateTimeFormat(undefined, { month: "short", day: "numeric", year: "numeric", }).format(lastBillingDate.getTime());
          this.noteUsage.end = Intl.DateTimeFormat(undefined, { month: "short", day: "numeric", year: "numeric", }).format(nextBillingDate.getTime());
          new QueryManager({ paged: true, pageSize: 1 }).getNotesWith({
            filters: [{ field:"date_filter", value: [parseInt(lastBillingDate.getTime() / 1000), parseInt(nextBillingDate.getTime() / 1000)], op: Operators.BT, type: SupportedTypes.INT }],
            page: 1,
            NoteView: NoteViews.ALL,
          }).then(x => {
            this.noteUsage.notesUsedInPeriod = x.data.total_count;
          });
        }
      })
      .catch((e) => {
        console.error("failed to get page data:" + e);
      })
      .finally(() => {
        this.loading = false;
      });
    if (this.$store.getters.getUserPerms.user_management) {
      // need to get the accurate user count and their set of permissions
      // if we provided number of dictation users in the sub resp body like we do with verified users this might be able to be avoided

      Promise.allSettled([SubscriptionService.GetSubscriptionUsers(), SubscriptionService.GetInvites(), subPromise])
        .then(resps => {
          this.userList = resps[0].value.data.users;
          this.inviteList = resps[1].value.data.invites;
          this.buildDoughnutChart();
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loadingUserManagement = false;
        });

    }

    this.loadingNotes = true;
    this.queryManager.getNotesWith({
      filters: [{ field: 'date_filter', value: [0, parseInt(new Date().getTime() / 1000)], op: Operators.BT, type: SupportedTypes.INT }],
      sorting: { field: "date", sortBy: Sorting.DESCENDING },
      noteView: NoteViews.ACTIVE,
      page: 1,
    })
      .then(resp => {
        this.parseNotesToPreview(resp.data.notes);
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loadingNotes = false;
      });

  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    isUserVerified () {
      return this.$store.getters.getUserPerms.verified;
    },
    isUserScribe () {
      if (!this.$store.getters.getUserGroups) return false;
      return this.$store.getters.getUserGroups.findIndex(x => x === "Scribe") !== -1;
    },
    doneSetupSteps () {
      return this.setupSteps.filter(x => x.done()).length;
    },

    // sorts "done" setup steps first, non-done last. can't be sorted in v-dom, vue's v-node renderer handles the sort differently
    sortedSetupSteps () {
      // explanation: sort for the progress bar made for setup steps
      // extra equality check to preserve order where possible
      return this.setupSteps.sort((a, b) => { a.done() == b.done() ? 0 : a.done() ? -1 : 1; });
    },
    userPerms () {
      return this.$store.getters.getUserPerms;
    },
    featureFlags () {
      return this.$store.getters.getFeatureFlags;
    },
  },
  methods: {
    parseNotesToPreview (notes) {
      let map = {};
      notes.forEach((note) => {
        let ts = 0;
        if (note.state == 0 || note.state == 5) {
          ts = note.created_at;
        } else if (note.published_at == 0)
          ts = note.last_edited;
        else {
          ts = note.published_at;
        }
        note.sortDate = ts;
        // ts in ms at midnight
        note.displayDate = {
          date: Intl.DateTimeFormat(undefined, { month: "short", day: "numeric", year: "numeric", }).format(ts * 1000),
          time: Intl.DateTimeFormat(undefined, { hour: "numeric", minute: "numeric" }).format(ts * 1000),
        };
        note.mapDate = new Date(ts * 1000).setHours(0, 0, 0, 0);
      });
      if (this.isUserScribe) {
        notes.sort((a, b) => {
          if (a.needs_attention) {
            return -1;
          }
        });
      }
      notes.sort((a, b) => {
        return a.sortDate === b.sortDate ? 0 :
          a.sortDate < b.sortDate ? 1 : -1;
      });
      if (!this.isUserScribe) {
        notes.sort((a, b) => {
          if (a.needs_attention) {
            return -1;
          }
        });
      }
      notes.forEach((note) => {
        let label = "";
        if (note.needs_attention && !this.isUserScribe) {
          label = 'Needs Attention';
        } else {
          label = new Date(note.mapDate).toString().slice(0, 11);
        }
        if (!map[label]) {
          map[label] = [];
        }
        map[label].push(note);
      });

      Object.keys(map).forEach((key) => {
        this.recentNotes.push({ heading: key, notes: map[key] });
      });
    },
    trackNoteNav (note) {

      let subId = this.$store.getters.getSubscriptionId;
      MixpanelService.Track("AdminPortal:NoteNavigation", {
        subscription_id: subId,
        note_id: note.id,
        source: "dashboard",
      });
    },
    buildDoughnutChart () {

      // we don't provide the correct count of users with dictation permissions in the subscription.
      //Verified is correct, including invited users as well
      this.dictation = this.userList.filter(x => x.permissions.dictation).length
        + this.inviteList.filter(x => x.permissions.dictation).length;
      this.maxDictation = parseInt(this.subscription.product.number_of_users);
      this.verified = parseInt(this.subscription.number_of_verified_users);
      this.maxVerified = parseInt(this.subscription.verified_seats_available);
      this.invites = parseInt(this.subscription.pending_invites);


      this.dictationChartData = {
        datasets: [{
          labels: ['', ''],
          data: [this.dictation == 0 ? 0.01 : this.dictation, this.maxDictation - this.dictation], //integer list
          backgroundColor: ['rgba(3, 134, 183, 1)', 'rgba(229, 229, 229, 1)'],
          borderColor: ['rgba(3, 134, 183, 1)', 'rgba(229, 229, 229, 1)'],
        }]
      };
      this.verifiedChartData = {
        datasets: [{
          labels: ['', ''],
          data: [this.verified == 0 ? 0.01 : this.verified, this.maxVerified - this.verified], //integer list
          backgroundColor: ['rgba(3, 183, 142, 1)', 'rgba(229, 229, 229, 1)'],
          borderColor: ['rgba(3, 183, 142, 1)', 'rgba(229, 229, 229, 1)'],
        }]
      };
    },
  },
};
